import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=7fa3d3a8&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=ts"
export * from "./Step4.vue?vue&type=script&lang=ts"
import style0 from "./Step4.vue?vue&type=style&index=0&id=7fa3d3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3d3a8",
  null
  
)

export default component.exports